import * as React from 'react'
import { Button } from 'react-bootstrap'

interface EditInstantArticleProps {
	showInstantArticle: () => void
	articleNum: number
}

const EditInstantArticleButton: React.FunctionComponent<EditInstantArticleProps> = (props) => {
	return (
		<Button
			style={{ marginTop: '20px', backgroundColor: '#589da6' }}
			id="editInstantArticle"
			bsStyle="success"
			onClick={props.showInstantArticle}
		>
			Edit Instant Article {props.articleNum}
		</Button>
	)
}

export default EditInstantArticleButton
